import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import CreateConsignment from "../pages/Consignment/CreateConsignment";
import EditConsignment from "../pages/Consignment/EditConsignment";
import {
  PermissionRequired,
  AccessControl,
} from "@careinfo/permission-required";
import { OrderList } from "../pages/Consignment/ConsignmentList";

export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path="/" element={<OrderList />} />
          <Route path="/order" element={<OrderList />} />
          <Route
            path="/create"
            element={
              <AccessControl
                children={<CreateConsignment />}
                allowedPermissions={["can_view_consignment"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path="/edit/:id"
            element={
              <AccessControl
                children={<EditConsignment />}
                allowedPermissions={["can_view_consignment"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={1000} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
